"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helper_1 = require("./helper");
var ComposeType;
(function (ComposeType) {
    ComposeType[ComposeType["New"] = 0] = "New";
    ComposeType[ComposeType["Reply"] = 1] = "Reply";
    ComposeType[ComposeType["ReplyAll"] = 2] = "ReplyAll";
    ComposeType[ComposeType["Forward"] = 3] = "Forward";
    ComposeType[ComposeType["EditDraft"] = 4] = "EditDraft";
    ComposeType[ComposeType["Approve"] = 5] = "Approve";
    ComposeType[ComposeType["Reject"] = 6] = "Reject";
})(ComposeType = exports.ComposeType || (exports.ComposeType = {}));
class Attachment {
    constructor(fileName, fileType) {
        this.fileName = fileName;
        this.fileType = fileType;
    }
}
exports.Attachment = Attachment;
class Constraint {
    constructor(key, value) {
        this.key = key;
        this.value = value;
    }
}
exports.Constraint = Constraint;
class UrlParam {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
exports.UrlParam = UrlParam;
class Recipient {
    constructor(address, name, mailboxType) {
        this.address = address;
        this.name = name;
        if (mailboxType) {
            this.mailboxType = helper_1.getType(mailboxType);
        }
    }
}
exports.Recipient = Recipient;
class Email {
    constructor(subject, sender, to, cc, bcc, date, body) {
        this.subject = subject;
        this.sender = sender;
        this.to = to;
        this.cc = cc;
        this.bcc = bcc;
        this.date = date;
        this.body = body;
    }
}
exports.Email = Email;
class Envelope {
    constructor(subject, to, cc, bcc, attached) {
        this.subject = subject;
        this.to = to;
        this.cc = cc;
        this.bcc = bcc;
        this.attached = attached;
    }
}
exports.Envelope = Envelope;
class Actor {
    constructor(actorId, actorIdType, aadTenantId, actorType = "User") {
        this.actorId = "PUID:" + actorId;
        this.actorIdType = actorIdType;
        this.aadTenantId = aadTenantId;
        this.actorType = actorType;
    }
}
exports.Actor = Actor;
class Application {
    constructor(appId, appName, appVer) {
        this.aadAppId = appId;
        this.appName = appName;
        this.appVer = appVer;
    }
}
exports.Application = Application;
class Device {
    constructor(os, osVer, userAgent) {
        this.os = os;
        this.osVer = osVer;
        this.userAgent = userAgent;
    }
}
exports.Device = Device;
class SessionInfo {
    constructor(actor, application, device, composeType) {
        this.actor = actor;
        this.application = application;
        this.device = device;
        this.composeType = composeType;
    }
}
exports.SessionInfo = SessionInfo;
